/**
 * SelectedAchievementStandardsField — 일괄 생성용 성취기준 요약 (docs/achievement_standards_ux.md §2-3, D2)
 *
 * 일괄 생성에는 교사가 보는 프롬프트 textarea가 없으므로 칩이 곧 선택의 표현이다.
 * 진입 행은 단일 생성과 같은 AchievementStandardEntry를 쓴다.
 */

import React from 'react';
import AchievementStandardEntry from './AchievementStandardEntry';
import {
  isCurriculum2015,
  isLocatorCode,
  isSpecialCurriculum,
  recordIdentity,
} from './achievementStandardPicker.utils';
import './SelectedAchievementStandardsField.css';

const SUBJECT_CATEGORIES = new Set(['교과', '교과_고등']);
const TEXT_LIMIT = 36;

const truncateText = (text) => {
  const value = String(text || '').trim();
  if (value.length <= TEXT_LIMIT) return value;
  return `${value.slice(0, TEXT_LIMIT)}…`;
};

const chipLabel = (record) => {
  const code = isLocatorCode(record) ? '' : String(record?.code || '').trim();
  const text = truncateText(record?.text);
  return [code, text].filter(Boolean).join(' ');
};

const SelectedAchievementStandardsField = ({
  category,
  notice,
  onOpenPicker,
  onRemove,
  selectedStandards = [],
}) => {
  if (!SUBJECT_CATEGORIES.has(category)) return null;

  return (
    <div className="sasf" data-testid="sasf-field">
      <span className="sasf__label">성취기준</span>
      {selectedStandards.length > 0 && (
        <ul className="sasf__chips">
          {selectedStandards.map((record) => (
            <li
              className="sasf__chip"
              data-testid={`sasf-chip-${record.key}`}
              key={recordIdentity(record)}
            >
              <span className="sasf__chip-text">{chipLabel(record)}</span>
              {isCurriculum2015(record) && (
                <span className="sasf__curriculum" data-testid="sasf-curriculum-2015">2015</span>
              )}
              {isSpecialCurriculum(record) && (
                <span className="sasf__curriculum" data-testid="sasf-curriculum-special">특수</span>
              )}
              {isLocatorCode(record) && (
                <span className="sasf__curriculum" data-testid="sasf-locator" title="고시에 성취기준 코드가 없는 과목이에요">
                  고시 코드 아님
                </span>
              )}
              <button
                aria-label={`${record.code || '성취기준'} 빼기`}
                className="sasf__remove"
                data-testid={`sasf-remove-${record.key}`}
                onClick={() => onRemove(record)}
                type="button"
              >
                ✕
              </button>
            </li>
          ))}
        </ul>
      )}
      <AchievementStandardEntry
        hint="모든 학생에게 공통으로 들어가요"
        notice={notice}
        onOpen={onOpenPicker}
        testId="asp-open-batch"
      />
    </div>
  );
};

export default SelectedAchievementStandardsField;
